import React from 'react';

const features = [
  {
    id: 'natural-flavours',
    title: 'arome naturale',
    description: 'arome naturale autentice din ingrediente selectate cu grijă',
  },
  {
    id: 'premium-vodka',
    title: 'vodcă premium',
    description: 'distilată fin, netedă și rafinată până la perfecțiune',
  },
  {
    id: 'bold-taste',
    title: 'gust intens',
    description: 'creată din ingrediente de calitate pentru un gust delicios și intens',
  },
  {
    id: 'low-calories',
    title: 'sărac în calorii',
    description: '86 de calorii, fără gluten',
  },
];

const FeaturesSection = () => {
  return (
    <section data-testid="features-section" className="py-20 sm:py-28 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-14">
          <h2
            className="text-[#0a0a0a] font-black italic leading-tight mb-4"
            style={{
              fontFamily: 'Nunito, sans-serif',
              fontSize: 'clamp(2rem, 5vw, 3.5rem)',
            }}
          >
            noua ta băutură preferată
          </h2>
        </div>

        {/* Feature cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature) => (
            <div
              key={feature.id}
              data-testid={`feature-card-${feature.id}`}
              className="bg-[#0a0a0a] rounded-2xl p-6 sm:p-8 text-center hover:scale-105 transition-transform duration-300"
            >
              <h3
                className="text-white font-black italic text-lg sm:text-xl mb-3"
                style={{ fontFamily: 'Nunito, sans-serif' }}
              >
                {feature.title}
              </h3>
              <p
                className="text-white/60 text-sm leading-relaxed"
                style={{ fontFamily: 'Nunito, sans-serif' }}
              >
                {feature.description}
              </p>
            </div>
          ))}
        </div>

        {/* Specs */}
        <div className="mt-16 bg-[#0a0a0a] rounded-3xl p-8 sm:p-12">
          <h3
            className="text-white font-black italic text-2xl text-center mb-8"
            style={{ fontFamily: 'Nunito, sans-serif' }}
          >
            în fiecare doză
          </h3>
          <div className="grid grid-cols-3 gap-6 max-w-lg mx-auto">
            {[
              { value: '5%', label: 'alcool' },
              { value: '86', label: 'calorii' },
              { value: '250ml', label: 'per doză' },
            ].map((spec) => (
              <div key={spec.label} className="text-center">
                <p
                  className="text-white font-black italic text-3xl sm:text-4xl mb-1"
                  style={{ fontFamily: 'Nunito, sans-serif' }}
                >
                  {spec.value}
                </p>
                <p
                  className="text-white/50 text-xs sm:text-sm font-semibold"
                  style={{ fontFamily: 'Nunito, sans-serif' }}
                >
                  {spec.label}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
